import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    show_price_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        width: '100%'
    },
    stock_item: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 12px',
        backgroundColor: theme.palette.grey[50],
        borderRadius: '6px',
        borderLeft: `3px solid ${theme.palette.grey[300]}`,
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: theme.palette.grey[100],
            transform: 'translateX(2px)'
        }
    },
    stock_item_positive: {
        borderLeftColor: theme.palette.success.main,
        '&:hover': {
            borderLeftColor: theme.palette.success.dark,
        }
    },
    stock_item_negative: {
        borderLeftColor: theme.palette.error.main,
        '&:hover': {
            borderLeftColor: theme.palette.error.dark,
        }
    },
    title: {
        fontSize: '11px',
        color: theme.palette.grey[600],
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '2px'
    },
    number: {
        fontFamily: 'Alkatra, cursive',
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: 1,
        "& > span:last-child": {
            fontSize: '20px',
        }
    },
    positive: {
        color: theme.palette.success.main
    },
    negative: {
        color: theme.palette.error.main
    },
    label_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px'
    },
    value_container: {
        display: 'flex',
        alignItems: 'center'
    }
}));

export {useStyles}
